import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { JiraService } from "../../services/jira/jira.service";
import { SyncProgressService } from "../../services/sync-progress/sync-progress.service";
import { JiraProject } from "../../interfaces/jiraProject";
import { MzToastService } from "ng2-materialize";
import { environment } from "../../../environments/environment";
import { MzBaseModal } from "ng2-materialize";
import { EventEmitter } from "@angular/core";
import { Observable } from "rxjs/Rx";
import { UUID } from "angular2-uuid";

@Component({
  selector: "app-jira-import",
  templateUrl: "./jira-import.component.html",
  styleUrls: ["./jira-import.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class JiraImportComponent extends MzBaseModal implements OnInit {
  env: any = environment;
  jiraProjects: Array<JiraProject>;
  jiraStatus: number = 0;
  jiraUrl: string;
  jiraAuthorizeUrl: string;
  jiraConsumerKey: string;
  projectCreated: EventEmitter<any> = new EventEmitter();
  projectSelection: number;
  selectedProject = "Projekt auswählen" as string;
  selectedIssueTracker = "Issue Tracker auswählen" as string;
  projectSelectionEnabled: boolean = false;
  progress: Observable<number>;

  constructor(
    private toastService: MzToastService,
    private jiraService: JiraService,
    private syncProgressService: SyncProgressService
  ) {
    super();
  }

  async ngOnInit() {
    await this.loadJiraProjects();
    Observable.timer(0, 5000).subscribe(async (_) => {
      if (this.jiraStatus === 6) await this.loadJiraProjects();
    });

    // Select Jira by default
    this.setIssueTrackerSelection("JIRA");
  }

  async loadJiraProjects() {
    let waitingForAuth = this.jiraStatus === 6;
    this.jiraStatus = 0;
    let response = await this.jiraService.getProjects();
    if (response.message === "not_configured") {
      this.jiraStatus = 2;
    } else if (response.message !== undefined) {
      if (waitingForAuth) this.jiraStatus = 6;
      else this.connectJira();
    } else {
      this.jiraProjects = response.JiraProjectResponse.jiraprojects.sort(
        (x, y) =>
          x.projectName.localeCompare(y.projectName, undefined, {
            sensitivity: "base",
            ignorePunctuation: true,
            usage: "sort",
          })
      );
      this.projectSelection = this.jiraProjects[0].id;
      this.jiraStatus = 1;
    }
  }

  openAuthorisation() {
    this.jiraStatus = 6;
    window.open(this.jiraAuthorizeUrl, "_blank");
  }

  async connectJira() {
    this.jiraStatus = 0;
    let response = await this.jiraService.authorize(this.jiraUrl);
    if (response.message === "not_linked") {
      this.jiraConsumerKey = response.consumer_key;
      this.jiraStatus = 3;
    } else if (response.message === "not_authorized") {
      this.jiraStatus = 4;
      this.jiraAuthorizeUrl = response.authorize_url;
    } else {
      this.jiraStatus = 99;
    }
  }

  async importProject() {
    try {
      this.jiraStatus = 5;
      let progressId = UUID.UUID();
      this.progress = this.syncProgressService.watch(progressId);
      await this.jiraService.importProject(this.projectSelection, progressId);
      this.projectCreated.emit(null);
      this.modalComponent.close();
      this.toastService.show(
        "Projekt erfolgreich importiert!",
        4000,
        "confirm-toast"
      );
    } catch (reason) {
      this.jiraStatus = 1;
      this.toastService.show(
        "Fehler beim Import: " + reason.statusText,
        4000,
        "notification-toast"
      );
    }
  }

  setProjectSelection(selection: number, selectedProject: string) {
    this.projectSelection = selection;
    this.selectedProject = selectedProject;
  }

  setIssueTrackerSelection(selectedIssueTracker: string) {
    this.selectedIssueTracker = selectedIssueTracker;
    this.projectSelectionEnabled = true;

    this.projectSelection = -1;
    this.selectedProject = "Projekt auswählen";
  }

  toastCopyToClipboard() {
    this.toastService.show(
      "Key wurde in die Zwischenablage kopiert!",
      4000,
      "confirm-toast"
    );
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/jira-import/jira-import.component.ts